<div class="drawer-custom drawer">
  <div class="drawer-overlay" (click)="onDismiss()"></div>

  <div class="drawer-panel">
    <div class="drawer-header px-2 py-1 d-flex align-items-center justify-content-between">
      <h4 class="drawer-title mb-0">{{ title }}</h4>
      <button type="button" class="btn btn-icon" (click)="onDismiss()" aria-label="Fechar">
        <i class="feather icon-x"></i>
      </button>
    </div>

    <div class="drawer-body" #scrollBody tabindex="0" ngbAutofocus>
      <div *ngIf="isLoading" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Carregando...</span>
        </div>
      </div>

      <div *ngIf="!isLoading && hasError" class="text-center py-4">
        <p class="text-muted mb-2">Não foi possível carregar os comentários.</p>
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="retry()">
          Tentar novamente
        </button>
      </div>

      <ng-container *ngIf="!isLoading && !hasError">
        <p class="text-muted small mb-1" *ngIf="highlightedEmployeeId">
          Exibindo apenas comentários do respondente selecionado.
        </p>

        <div *ngIf="items.length === 0" class="text-muted text-center py-4">
          {{
            highlightedEmployeeId
              ? 'Este respondente não deixou comentário nesta pergunta.'
              : 'Nenhum comentário encontrado.'
          }}
        </div>

        <div
          *ngFor="let comment of items"
          class="card card-fit comment-card mb-1"
          [class.comment-card--highlighted]="comment.isHighlighted">
          <div class="card-body py-1 px-1">
            <span *ngIf="comment.isHighlighted" class="comment-badge">Respondente selecionado</span>
            <p class="mb-50"><em>"{{ comment.text }}"</em></p>
            <small class="text-muted" *ngIf="comment.submittedAt">
              {{ comment.submittedAt | date: 'dd/MM/yyyy HH:mm' }}
            </small>
          </div>
        </div>

        <div #scrollSentinel class="scroll-sentinel" *ngIf="hasMore" aria-hidden="true"></div>

        <div *ngIf="isLoadingMore" class="text-center py-2">
          <div class="spinner-border spinner-border-sm text-primary" role="status">
            <span class="sr-only">Carregando mais...</span>
          </div>
        </div>

        <p
          class="drawer-count-end text-muted small text-center mb-0 mt-1"
          *ngIf="total > 0 && !hasMore && !isLoadingMore">
          Todos os comentários foram carregados.
        </p>
      </ng-container>
    </div>

    <div class="drawer-footer d-flex align-items-center justify-content-between p-2">
      <small class="drawer-count text-muted" *ngIf="!isLoading && !hasError && total > 0">
        Exibindo {{ items.length }} de {{ total }}
        {{ total === 1 ? 'comentário' : 'comentários' }}
      </small>
      <span *ngIf="isLoading || hasError || total === 0"></span>
      <button type="button" class="btn btn-outline-primary" (click)="onDismiss()" rippleEffect>
        Fechar
      </button>
    </div>
  </div>
</div>
